import React, { createContext, useContext, useState } from "react";

interface ICheckedResponsavel {
    checked: number[];
    handleSetChecked: (id: number) => void;
}

const CheckedResponsavelContext = createContext({} as ICheckedResponsavel);

const CheckedResponsavelProvider: React.FC = ({ children }) => {
    const [checked, setChecked] = useState([]);

    const handleSetChecked = (id: number) => {
        setChecked((prevChecked: any) => {
            if (prevChecked.includes(id)) {
                return prevChecked.filter((item: number) => item !== id);
            } else {
                return [...prevChecked, id];
            }
        });
    }

    return (
        <CheckedResponsavelContext.Provider
            value={{ checked, handleSetChecked }}
        >
            {children}
        </CheckedResponsavelContext.Provider>
    );
};

const useCheckedResponsavel = () => {
    const checkedResponsavel = useContext(CheckedResponsavelContext);
    return checkedResponsavel;
};

export { CheckedResponsavelProvider, useCheckedResponsavel };
